import { normalize } from "path";


class FilterWrapper {
    constructor() {
        this.$cp = qs('.CP-filter-wrapper');
        this.$tabs = qsa(this.$cp, '.tabs button');
        this.$current = qs(this.$cp, '.current');
        this.$span = qs(this.$current, 'span')
        this.$listBox = qs(this.$cp, '.menu ul')
        this.$list = qsa(this.$listBox, 'li');
        this.$pushes = qsa(this.$cp, '.CP-house-push')
        this.$plusBtn = qs(this.$cp, '.CP-plus');
        this.$wrapper = qs(this.$cp, '.wrapper');
        this.$noResults = qs(this.$cp, '.no-results')
        this.displayCount = 1;
        this.data = {
            themes: "editer",
            univers: ""
        }
        this.LIMIT_ITEMS = 3;
        
    }

    onLoad() {
        this.handleTabClick();
        this.chooseUnivers();
        this.plus();
        this.displayPushes();
    }

    handleTabClick() {
        // on click on the tab
        for (let i = 0; i < this.$tabs.length; i++) {
            click(this.$tabs[i], e => {
                // set active class
                e.target.className = 'active';

                // set the others
                for (let j = 0; j < this.$tabs.length; j++) {
                    if (j != i) {
                        this.$tabs[j].className = 'not-active';
                    }
                }

                // update dataset
                this.data.themes = e.target.dataset.filtertheme;

                // update the display
                this.displayPushes(false);
            });
        }
    }

    displayPushes(forceAll) {
        warn('display');
        this.$plusBtn.style.display = 'block';
        this.$pushes.forEach(house => {
            house.classList.remove('displayed');
            house.style.border = ""
        });

        let items = this.getItems();
        let limit = (forceAll ? items.length : this.LIMIT_ITEMS);
        let i = 0;

        for (; i < limit; i++) {
            if (items[i]) {
                items[i].classList.add('displayed');
                //items[i].style.border = "2px red solid"
            }
            else {
                this.clearButton();
            }
        }

        if (!items[i]) {
            this.clearButton();
        }
        let noResults = false;
        if (qsa(this.$wrapper, '.displayed').length) noResults = false
        else noResults = true;
        this.$noResults.style.display = noResults ? 'block' : 'none';
    }

    clearButton() {
        this.$plusBtn.style.display = 'none'
        let items = this.getItems();
        if (items.length > 0) {
            // items[items.length - 1].style.marginBottom = "30px";
        }
    }

    chooseUnivers() {
        warn('choose');
        
        click(this.$current, () => this.$listBox.classList.toggle('list--active'))

        this.$list.forEach(choice => click(choice, () => {
            this.$span.innerHTML = choice.innerText
            this.data.univers = choice.dataset.filterunivers
            this.$listBox.classList.remove('list--active')
            this.displayPushes(false)
        }))
        
    }

    plus() {
        click(this.$plusBtn, () => {
            this.displayPushes(true);
        })
    }

    getItems() {
        let result = [];
        this.$pushes.forEach(house => {
            const univers = house.dataset.univers;
            const themes = house.dataset.themes;

            if (univers.includes(this.data.univers) && themes.includes(this.data.themes)) {
                result.push(house);
            }
        });

        return result;
    }





    // customDisplay(isUnivers, isTheme) {
    //     this.displayPushes()
    //     // this.$pushes.forEach(house => house.style.display = `none`)
    //     this.$pushes.forEach(house => {
    //         const univers = house.dataset.univers;
    //         const themes = house.dataset.themes;

    //         if (isUnivers && !isTheme) {
    //             if (univers.includes(this.data.univers)) {
    //                 house.style.border = "2px red solid"
    //             } else {
    //                 house.style.border = "2px blue solid"
    //                 house.style.display = 'none';
    //             }
    //         }

    //         if (!isUnivers && isTheme) {
    //             if (themes.includes(this.data.themes)) {
    //                 house.style.border = "2px red solid"
    //             } else {
    //                 house.style.border = "2px blue solid"
    //                 house.style.display = 'none';
    //             }
    //         }

    //         if (isUnivers && isTheme) {
    //             if (univers.includes(this.data.univers) && themes.includes(this.data.themes)) {
    //                 house.style.border = "2px red solid"
    //             } else {
    //                 house.style.border = "2px blue solid"
    //                 house.style.display = 'none';
    //             }
    //         }
    //     })
    // }
}

ready(qs('.CP-filter-wrapper'), () => {
    const CP = new FilterWrapper();
    CP.onLoad()
})


// WEBPACK FOOTER //
// ./src/scripts/components/FilterWrapper.js